import { createAction, createReducer, on, props } from '@ngrx/store';
import { TimeslotReducerInitState } from '../models/timeslot-reducer.interface';

// Action Types
export const updateTimeslotFormatted = createAction('updateTimeslotFormatted', props<{ data: any }>());
export const updateSelectedDate = createAction('updateSelectedDate', props<{ selectedDate: string }>());
export const updateSelectedGroup = createAction('updateSelectedGroup', props<{ selectedGroup: string }>());
export const updateSelectedTimeslotId = createAction('updateSelectedTimeslotId', props<{ selectedTimeslotId: string }>());
export const updateSelectedTimeslotOverrideCapacity = createAction('updateSelectedTimeslotOverrideCapacity', props<{ overrideCapacity: boolean }>());
export const updateSelectedTimeslotDateTime = createAction('updateSelectedTimeslotDateTime', props<{ dateTime: string }>());
export const updateSelectedPostcode = createAction('updateSelectedPostcode', props<{ selectedPostcode: string }>());
export const updateUsedPromo = createAction('updateUsedPromo', props<{ usedPromo: boolean }>());
export const refreshTimeslotState = createAction('refreshTimeslotState', props<{ state: any }>());
export const resetTimeslotState = createAction('resetTimeslotState');
export const updateCurrency = createAction('updateCurrency', props<{ currency: any }>());
export const updateCutOffWindow = createAction('updateCutOffWindow', props<{ cutOffTimeWindow: string }>());

// Initial State
const initState: TimeslotReducerInitState = {
  timeslotFormattedData: null,
  selectedDate: null,
  selectedGroup: null,
  selectedTimeslotId: null,
  selectedTimeslotOverrideCapacity: null,
  selectedTimeslotDateTime: null,
  selectedPostcode: null,
  usedPromo: false,
  currency: { code: 'GBP', symbol: '£' },
  cutOffTimeWindow: null
};

// Reducer
export const timeslotReducer = createReducer(
  initState,
  on(updateTimeslotFormatted, (state, { data }) => ({ ...state, timeslotFormattedData: data })),
  on(updateSelectedDate, (state, { selectedDate }) => ({ ...state, selectedDate })),
  on(updateSelectedGroup, (state, { selectedGroup }) => ({ ...state, selectedGroup })),
  on(updateSelectedTimeslotId, (state, { selectedTimeslotId }) => ({ ...state, selectedTimeslotId })),
  on(updateSelectedTimeslotOverrideCapacity, (state, { overrideCapacity }) => ({ ...state, selectedTimeslotOverrideCapacity: overrideCapacity })),
  on(updateSelectedTimeslotDateTime, (state, { dateTime }) => ({ ...state, selectedTimeslotDateTime: dateTime })),
  on(updateSelectedPostcode, (state, { selectedPostcode }) => ({ ...state, selectedPostcode })),
  on(updateUsedPromo, (state, { usedPromo }) => ({ ...state, usedPromo })),
  on(refreshTimeslotState, (state, { state: newState }) => ({ ...newState })),
  on(resetTimeslotState, () => ({ ...initState })),
  on(updateCurrency, (state, { currency }) => ({ ...state, currency })),
  on(updateCutOffWindow, (state, { cutOffTimeWindow }) => ({ ...state, cutOffTimeWindow }))
);
